<div *ngIf="showLabel && label" class="intl-tel-input-label" [ngClass]="{'error-text' : showRequiredError}" >{{ label }}</div>
<input
  #telInput
  id="phone"
  type="tel"
  class="phone-input"
  [(ngModel)]="phoneNumber"
  (ngModelChange)="onPhoneNumberChange()"
  (blur)="onInputBlur()"
  value="+1"
  [disabled]="disabled"
  [ngClass]="{'disabled-input': disabled, 'error-border': showRequiredError}"
>
<div class="error-text" *ngIf="showRequiredError">{{errorMessage}}</div>
